module.exports = __webpack_public_path__ + "static/img/wechat_code2.169827f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_code2.jpg
// module id = MRTT
// module chunks = 13